import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { PainPoints } from './components/PainPoints';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-amber-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Bonuses data-id="element-7" />
        <CallToAction data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}